const h = (v) => Math.max(parseInt(v) || 0, 0);

// Par bloc : formation = complet - allégement ; R1 = Z1 + Z2 + Z3 + F3 (stage à part)
export const recapPif = (pif = {}) => {
  const lignes = [1, 2, 3].map((n) => {
    const d = pif[`bc${n}`] || pif[`uc${n}`] || {};
    return { key: `bc${n}`, nom: `BC${n}`, d };
  });
  lignes.push({ key: 'foad', nom: 'FOAD', d: pif.foad || {} });
  const rows = lignes.map(({ key, nom, d }) => {
    const complet = h(d.heures_complete ?? d.heures);
    const allegement = Math.min(h(d.heures_allegee), complet);
    return { key, nom, complet, allegement, formation: complet - allegement };
  });
  const total = rows.reduce((s, r) => s + r.formation, 0);
  const allegements = rows.reduce((s, r) => s + r.allegement, 0);
  return { rows, total, allegements };
};

export const PifRecapTable = ({ pif, stage, testPrefix = 'pif-recap' }) => {
  const { rows, total } = recapPif(pif);
  return (
    <div className="overflow-x-auto" data-testid={`${testPrefix}-table`}>
      <table className="w-full text-xs sm:text-sm border border-slate-200 rounded-lg overflow-hidden">
        <thead>
          <tr className="bg-[#8DC63F] text-white">
            <th className="text-left px-2 sm:px-3 py-2 font-semibold">Bloc</th>
            <th className="text-center px-2 sm:px-3 py-2 font-semibold">Complet</th>
            <th className="text-center px-2 sm:px-3 py-2 font-semibold">Allég<span className="hidden sm:inline">ement</span></th>
            <th className="text-center px-2 sm:px-3 py-2 font-semibold">Formation</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.key} className="border-t border-slate-100" data-testid={`${testPrefix}-row-${r.key}`}>
              <td className="px-2 sm:px-3 py-2 font-medium text-slate-700">{r.nom}<span className="hidden sm:inline"> complet</span></td>
              <td className="px-2 sm:px-3 py-2 text-center text-slate-700">{r.complet} h</td>
              <td className="px-2 sm:px-3 py-2 text-center text-amber-600 whitespace-nowrap">- {r.allegement} h</td>
              <td className="px-2 sm:px-3 py-2 text-center font-bold text-slate-800" data-testid={`${testPrefix}-${r.key}-formation`}>
                {r.formation} h
              </td>
            </tr>
          ))}
          <tr className="border-t-2 border-[#8DC63F] bg-green-50">
            <td className="px-2 sm:px-3 py-3 font-bold text-slate-800" colSpan={3}>
              Total heures du candidat
              <span className="block text-xs font-normal text-slate-500">
                {rows.map((r) => r.nom).join(' + ')} = {rows.map((r) => `${r.formation} h`).join(' + ')}
              </span>
            </td>
            <td className="px-2 sm:px-3 py-3 text-center text-lg sm:text-xl font-bold text-green-600" data-testid={`${testPrefix}-total`}>
              {total} h
            </td>
          </tr>
        </tbody>
      </table>
      {stage !== undefined && stage !== null && (
        <p className="mt-2 text-xs text-slate-500" data-testid={`${testPrefix}-stage`}>
          Pour information : {stage} h de stage en entreprise (non comptées dans le total).
        </p>
      )}
    </div>
  );
};
